/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { jingleCollectionModelSchema } from "./jingleCollectionModelSchema.ts";
import { z } from "zod";

export const jingleCollectionModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => jingleCollectionModelSchema))
    })